import React from "react";
import TagManager from "react-gtm-module";
import "./assets/css/App.css";
import AllPages from "./routes/routes";

const tagManagerArgs = {
  gtmId: "GTM-NCBTVTL",
};

TagManager.initialize(tagManagerArgs);

function App() {
  return (
    <>
      <AllPages />
    </>
  );
}

export default App;
